import { GROUP } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/GroupModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { toast } from 'react-toastify';
import { ROUTES } from 'shared/consts';

const init = () => ({
  type: GROUP.EDIT_GROUP_INIT,
});

const success = () => ({
  type: GROUP.EDIT_GROUP_SUCCESS,
});

const failure = () => ({
  type: GROUP.EDIT_GROUP_FAILURE,
});

const editGroup = (groupData, history) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    await Connector.editGroup(groupData);
    dispatch(success());
    toast.success('Pomyślnie zaktualizowano dane grupy');
    dispatch(ViewManagementModule.Actions.hideLoader());
    history.push(ROUTES.INTERNAL_USERS_GROUPS);
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    toast.error('Nie udało się zaktualizować grupy');
    dispatch(failure());
  }
};

export default editGroup;
